import React, { Component } from 'react';
import image from '../../assets/img/vector/internet.svg';
import Section from '../../layout/Section';
import SectionContainer from '../../subcomponents/SectionContainer';

import ImageText from '../../subcomponents/ImageText';
import TextImage from '../../subcomponents/TextImage';
import imgBody1 from '../../assets/img/internet.jpg';
import img1 from '../../assets/img/flat/default.svg';
import img2 from '../../assets/img/flat/internet2.svg';
import img3 from '../../assets/img/flat/internet3.svg';
import IconBlock from '../../subcomponents/IconBlock28';

class Internet extends Component {

  componentDidMount() {
    document.title = 'Internet - Insacom';
  }

  render() {
    const content = [
      {
        id: 1,
        title: 'Enlaces Dedicados',
        description: 'Ancho de banda garantizado, Nacional e Internacional',
        img: img1
      },
      {
        id: 2,
        title: 'Conexión Estable y Robusta',
        description: 'Enlaces redundantes a los PITs más importantes del país',
        img: img2
      },
      {
        id: 3,
        title: 'Velocidad Simétrica',
        description: 'Todos nuestros enlaces cuentan con la misma velocidad de subida y descarga',
        img: img3
      }
    ];

    const descripcion =
      'Transforma tu negocio con acceso a Internet de nivel empresarial, robusto y confiable. Acceso dedicado y la mejor velocidad para que puedas aprovechar las ventajas del mundo hiperconectado.';

    return (
      <Section asuntoContacto={'Internet'}>
        <SectionContainer grey paddingTop={60} paddingBottom={40}>
          <ImageText
            no-padding
            image={image}
            title="Internet"
            description={descripcion}></ImageText>
        </SectionContainer>
        <SectionContainer>
          <IconBlock version={1} content={content}></IconBlock>
        </SectionContainer>
        <SectionContainer grey>
          <TextImage
            image={imgBody1}
            title="Características"
            description="Con el más avanzado software de monitoreo de enlaces dedicados para garantizar un óptimo servicio a nuestros clientes. Ofrecemos el servicio de monitoreo permanente en forma opcional para que su enlace pueda ser revisado 24/7/365.">
            <ul className="list-unstyled mb-0 mt-4">
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Disponibilidad en todo Chile, tome contacto con nosotros para tener más
                  información.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Eficiencia y Flexibilidad, Ancho de banda simétrico para cualquier tamaño de
                  empresa.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Red Robusta y resiliente, el tráfico es redireccionado dinámicamente en caso de
                  una interupción en el múcleo de la red.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Herramientas de monitoreo.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Servicio incluye acceso local, un router y direcciones IP válida.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Ofrecemos planes de Internet con tasa de contención 1:1 para que tenga siempre una
                  velocidad garantizada.
                </p>
              </li>
            </ul>
          </TextImage>
        </SectionContainer>
      </Section>
    );
  }
}

export default Internet;



// WEBPACK FOOTER //
// ./src/sections/telecomunicaciones/Internet.js